import React, { useRef, useState, useEffect } from 'react'
import { Icon, Label } from '@fluentui/react'
import { uniqueId } from 'lodash'

const UploadFile = ({ onUpdate, accept, label, multiple, required, onValidation, defaultValue }) => {

    const inputId = useRef(uniqueId('uploadFileInput_')).current
    const isDefaultLoaded = useRef(false)

    const [files, setFiles] = useState([])

    const mapDefaultFiles = (files) =>  files.map(x => ({
            name: x.fileName
        }))

    useEffect(() => {
        if (defaultValue && !isDefaultLoaded.current) {
            isDefaultLoaded.current = true
            setFiles(mapDefaultFiles(multiple ? defaultValue : [defaultValue]))

            if (onUpdate)
                onUpdate(multiple ? defaultValue.map(x => x.id).join(',') : defaultValue.id)
        }

        if (onValidation && required)
            onValidation(files.length > 0)
    }, [files])
    
    const removeFile = (fileName) => {
        const updatedFiles = files.filter(x => x.name !== fileName)
        setFiles(updatedFiles)
        
        if (onUpdate)
            onUpdate(multiple ? Array.from(updatedFiles) : updatedFiles[0])
    }

    const onUpload = (e) => {
        //If none selected, do nothing - dialog cancelled/closed
        if (e.target.files.length === 0)
            return

        const filesArray = Array.from(e.target.files)
        setFiles(filesArray)
        
        if (onUpdate)
            onUpdate(multiple ? filesArray : filesArray[0])
    }
    
    const warningIcon = <div className={`warning-inline warning-nolabel-small`} title="Field cannot be empty"><Icon  iconName="Warning"/></div>

    const warning = required && files.length === 0 ? warningIcon : null;
    const fileNames = files.map(x => <div key={x.name}>{x.name}  <Icon iconName='delete' onClick={() => removeFile(x.name)} styles={{root: {cursor: 'pointer', marginLeft: 4, verticalAlign: 'middle'}}} /></div>)

    return (
        <div style={{position: 'relative'}}>
            <Label
                htmlFor={inputId}
                styles={{root: {cursor: 'pointer', display: 'inline-block', '--hover-color': 'rgb(16, 110, 190)', '--hover-backgroundColor': 'rgb(243, 242, 241)'}}}
                className='customIcon'
            >
                <Icon iconName='upload' styles={{root: {color: 'rgb(0, 120, 212)', marginRight: 5}}} />
                {
                    label
                    ? label
                    : multiple
                        ? 'Select files'
                        : 'Select file'
                }
            </Label>
            <input id={inputId} type="file" accept={accept} hidden onChange={onUpload} multiple={multiple} />
            {warning}
            {fileNames}
        </div>
    )
}

export default UploadFile


// WEBPACK FOOTER //
// ./src/components/CustomComponents/UploadFile.js